import { useState, useEffect } from 'react';
import data from './data.json';
import './App.css';

function NodeList() {
  const [nodes, setNodes] = useState([]);

  useEffect(() => {
    setNodes(data);
  }, []);

  return (
    <div>
      <ul className="menu menu-lg  rounded-box w-56">
        {nodes.map((node, index) => (
          <li key={node.id || index}>
            <a href={node.url}>{node.name}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}

function App() {
  return (
    <div className="App background  flex justify-center items-center w-full h-screen">
      <div
        className="[--shadow:rgba(60,64,67,0.3)_0_1px_2px_0,rgba(60,64,67,0.15)_0_2px_6px_2px] w-4/5 h-auto rounded-2xl bg-white [box-shadow:var(--shadow)] max-w-[300px]"
      >
        <div
          className="flex flex-col items-center justify-between pt-9 px-6 pb-6 relative"
        >
          <span className="relative mx-auto -mt-16 mb-8">
          <svg t="1740294168321" class="icon" viewBox="0 0 1050 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2689" width="48" height="48"><path d="M779.344842 374.433684c-158.666105 0-269.500632 132.985263-269.500631 323.368421s110.834526 323.368421 269.500631 323.368421c158.666105 0 269.473684-132.985263 269.473684-323.368421s-110.807579-323.368421-269.473684-323.368421" fill="#7A3726" p-id="2690"></path><path d="M375.134316 24.117895c-206.282105 0-350.315789 177.313684-350.31579 431.157894s144.033684 431.157895 350.31579 431.157895c206.255158 0 350.315789-177.313684 350.315789-431.157895s-144.060632-431.157895-350.315789-431.157894" fill="#994530" p-id="2691"></path><path d="M428.921263 261.578105c0 69.955368-14.740211 140.018526-42.657684 202.644211a447.326316 447.326316 0 0 0-37.968842 180.709052v79.818106a26.947368 26.947368 0 0 1-53.894737 0v-79.818106c0-69.955368 14.740211-140.018526 42.630737-202.64421a446.922105 446.922105 0 0 0 37.995789-180.709053V159.151158a26.947368 26.947368 0 0 1 53.894737 0v102.426947" fill="#7A3726" p-id="2692"></path></svg>
          </span>
          <NodeList />
        </div>
      </div>

    </div>
  );
}

export default App;